<template>
  <div>
    <div v-show="!contacts.length">There are no contacts.</div>
    <div v-for="contact in contacts" :key="contact.siteContactId">
      <div v-if="contact.siteContact">
        <span><strong>{{contact.siteContact.firstName}} {{contact.siteContact.lastName}}</strong></span>
        <span v-if="contact.siteContact.title" class="contact.siteContact.title">{{contact.siteContact.title}}</span>
        <span v-if="contact.siteContact.email" class="contact.siteContact.email">e: {{contact.siteContact.email}}</span>
        <span v-if="contact.siteContact.phoneNumber" class="contact.siteContact.phone-number">p: {{contact.siteContact.phoneNumber}}</span>
        <span v-if="contact.siteContact.faxNumber" class="contact.siteContact.fax-number">f: {{contact.siteContact.faxNumber}}</span>
        <span v-if="contact.siteContact.address" class="contact.siteContact.address">{{contact.siteContact.address}}</span>
        <span v-if="contact.siteContact.city || contact.siteContact.state || contact.siteContact.zipCode" class="contact.siteContact.address">{{contact.siteContact.city}}, {{contact.siteContact.state}} {{contact.siteContact.zipCode}}</span>
        <div class="separator bottom"></div>
      </div>
      <div v-if="!contact.siteContact">
        <span><strong>{{contact.firstName}} {{contact.lastName}}</strong></span>
        <span v-if="contact.title" class="contact-title">{{contact.title}}</span>
        <span v-if="contact.email" class="contact-email">e: {{contact.email}}</span>
        <span v-if="contact.phoneNumber" class="contact-phone-number">p: {{contact.phoneNumber}}</span>
        <span v-if="contact.faxNumber" class="contact-fax-number">f: {{contact.faxNumber}}</span>
        <span v-if="contact.address" class="contact-address">{{contact.address}}</span>
        <span v-if="contact.city || contact.state || contact.zipCode" class="contact-address">{{contact.city}}, {{contact.state}} {{contact.zipCode}}</span>
        <div class="separator bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  props: {
    contacts: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}

.align-right {
  text-align: right;
}

span:after {
  content: "\A";
  white-space: pre;
}
</style>
